import styled from 'styled-components'
import { CSS } from 'ui/helpers'

const SearchButton = styled.button`
  position: absolute;
  right: calc(50% - 130px);

  display: flex;
  flex-direction: row;
  align-items: center;

  width: 260px;
  box-sizing: border-box;
  padding: 8px 12px;
  gap: 10px;

  background: inherit;
  border-radius: ${(p) => p.theme.uiKit.borderRadius.roundedModal};
  border-width: ${(p) => p.theme.uiKit.borderWidth.strokeS};
  border-color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
  border-style: solid;

  transition: all 0.3s;
  cursor: pointer;

  span {
    width: 100%;
    ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)};
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};

    text-align: left;
  }

  * {
    transition: all 0.3s;
  }

  svg {
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
  }

  &:hover {
    border-color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};

    > span {
      color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
    }

    svg path {
      color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};
    }
  }
`

export const s = {
  SearchButton
}
